<template>
  <div class="content">
    <h1>Kontahenci</h1>
    <div class="box box--wide">
      <div class="content-list" style="margin-top: 12px">
        <div class="content-list__item" v-for="contractor in contractors" :key="contractor.id">
          <div class="content-list__content">
            <span class="content-list__title">{{ contractor.name }}</span>
          </div>
          <button class="content-list__btn content-list__btn--normal" @click="editContractorModal(contractor.id)"><i class="fas fa-pen"></i></button>
          <button class="content-list__btn" @click="confirmDeleteContractor(contractor.id)"><i class="far fa-trash-alt"></i></button>
        </div>
        <small class="form-info" v-if="contractors.length == 0">Brak kontrachentów!</small>
      </div>
    </div>
    <div class="center-button">
      <button class="btn btn--gradient" @click="addContractorModal()" >Dodaj kontrahenta</button>
    </div>

    <!-- Edycja kontachenta -->
    <app-modal ref="contractorsForm">
      <form class="modal-form" @submit.prevent="saveContractor">
        <h1 v-if="form.id != null">Edytowanie kontrachenta</h1>
        <h1 v-else >Nowy kontrahent</h1>

        <app-input type="text" name="to_name" placeholder="Nazwa" required v-model="form.name"></app-input>
        <app-input type="text" name="to_vat" placeholder="NIP" required v-model="form.vat"></app-input>
        <app-input type="text" name="to_address" placeholder="Adres" required v-model="form.address"></app-input>
        <div class="modal-form__row">
          <app-input type="text" name="to_post_code" placeholder="Kod pocztowy" required v-model="form.post_code"></app-input>
          <app-input type="text" name="to_city" placeholder="Miasto" required v-model="form.city"></app-input>
        </div>
        <app-input type="text" name="to_email" placeholder="Email" v-model="form.email"></app-input>
        <div class="modal-form__row">
          <app-input type="text" name="to_phone" placeholder="Telefon" v-model="form.phone"></app-input>
          <app-input type="text" name="to_website" placeholder="Strona internetowa" v-model="form.website"></app-input>
        </div>
        <br>
        <button class="btn btn--gradient">Zapisz</button>
      </form>
    </app-modal>

    <!-- Potwierdz usunięcie -->
    <app-modal ref="deleteContractor">
      <div class="delete-confirm">
        <h1>Na pewno chcesz usunąć kontrachenta?</h1>
        <small>{{ contractorToDelete.name }}</small>
        <p>Tej operacji nie da się odwrócić!</p>
        <button class="btn btn--warn" @click="deleteContractor">Usuń</button>
      </div>
    </app-modal>
  </div>
</template>

<script>
import Modal from '@/layout/Modal.vue'
import Input from '@/components/Input.vue'
import {api} from '@/api'

export default {
  name: 'contractors',
  data() {
    return {
      contractors: [],
      form: {
        id: null,
        address: '',
        city: '',
        email: '',
        name: '',
        phone: '',
        post_code: '',
        vat: '',
        website: ''
      },
      contractorToDelete: {name: ''}
    }
  },
  computed: {
    orgID() {
      return this.$store.state.user.activeOrganization
    }
  },
  methods: {
    async init() {
      const response = await api.get(`/organizations/${this.orgID}/contractors`)
      this.contractors = response.data
    },
    editContractorModal(id) {
      const editedContractor = this.contractors.find(el => el.id == id)
      for(const key in this.form) {
        this.form[key] = editedContractor[key]
      }
      this.$refs.contractorsForm.activate()
    },
    addContractorModal(id) {
      for(const key in this.form) {
        this.form[key] = key == 'id' ? null : ''
      }
      this.$refs.contractorsForm.activate()
    },
    async saveContractor() {
      const response = (this.form.id == null) ? 
        await api.post(`/organizations/${this.orgID}/contractors`, this.form) : 
        await api.put(`/organizations/${this.orgID}/contractors/${this.form.id}`, this.form)

      this.$refs.contractorsForm.close()
      this.init()
    },
    confirmDeleteContractor(id) {
      this.$refs.deleteContractor.activate()
      this.contractorToDelete = this.contractors.find(el => el.id == id)
    },
    async deleteContractor() {
      const response = await api.delete(`/organizations/${this.orgID}/contractors/${this.contractorToDelete.id}`)
      this.init()
      this.$refs.deleteContractor.close()
    }
  },
  created() {
    this.init()
  },
  metaInfo: {
    title: 'Twoi kontahenci'
  },
  components: {
    appModal: Modal,
    appInput: Input,
  }
}
</script>

<style lang="scss">

</style>
